
import { useContext } from '@nuxtjs/composition-api';
import useCheckout from '@/composable/checkout/useCheckout';

export default {
  setup () {
    const { app } = useContext()
    const { setCheckoutState } = useCheckout(app)

    setCheckoutState()
  }
}
